Pluswerk.PlusProject.Form = Pluswerk.PlusProject.Form || {};

Pluswerk.PlusProject.Form.MagazineParameterHandler = function () {
    const ID_FORM = 'kundenmagazinMESSAGEkurz-13357';

    const init = function () {
        if (formExists()) {
            loadFormData();
        }
    };

    const formExists = function () {
        return Boolean(document.querySelector(`form#${ID_FORM}`));
    }

    const loadFormData = function () {
        const queryParams = window.location.search;
        const urlParams = new URLSearchParams(queryParams);
        urlParams.forEach((value, key)=> {
            const formElem = document.querySelector(`[name="${key}"]`);
            if (formElem) {
                formElem.value = value;
            }
        })
    };

    init();
};
